/* eslint-disable function-paren-newline */
import { FormElems } from 'components';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import './AccordionFields.scss';

const FormField = props => {
    const {
        field,
        isViewMode,
        item,
        fields,
        index,
        customFieldOptions,
    } = props;

    if (field.name === 'subMode') {
        const allFieldsValues = fields.getAll();
        if (allFieldsValues[index]?.paymentType) {
            field.props.data =
                customFieldOptions[allFieldsValues[index]?.paymentType];
        }
    }

    const fieldName = `${item}.${field.name}`;

    if (field.fieldType === 'select') {
        return (
            <Field
                name={fieldName}
                id={`${item}-${field.name}`}
                {...field.props}
                component={FormElems.Select}
                disabled={isViewMode}
            />
        );
    } else if (field.fieldType === 'radio') {
        return (
            <Field
                name={`${item}.${field.name}`}
                id={`${item}-${field.name}`}
                {...field.props}
                component={FormElems.Radio}
                disabled={isViewMode}
            />
        );
    } else if (field.fieldType === 'checkbox') {
        return (
            <Field
                name={`${item}.${field.name}`}
                id={`${item}-${field.name}`}
                {...field.props}
                component={FormElems.Checkbox}
                disabled={isViewMode}
            />
        );
    } else if (field.fieldType === 'switch') {
        return (
            <Field
                name={`${item}.${field.name}`}
                id={`${item}-${field.name}`}
                {...field.props}
                component={FormElems.Switch}
                isDisabled={isViewMode}
            />
        );
    }
    return (
        <Field
            name={fieldName}
            id={`${item}-${field.name}`}
            {...field.props}
            component={FormElems.Input}
            disabled={isViewMode}
        />
    );
};

FormField.propTypes = {
    field: PropTypes.object,
    testPrefix: PropTypes.string,
    isViewMode: PropTypes.bool,
    item: PropTypes.string,
    fields: PropTypes.array,
    index: PropTypes.number,
    customFieldOptions: PropTypes.object,
};

const DynamicFieldsController = ({
    fields,
    meta: { error, submitFailed },
    properties,
}) => {
    const {
        addButtonText,
        removeButtonText,
        isViewMode,
        configData,
        customFieldOptions,
        shouldShowRemove,
    } = properties;

    // Adding a default Field
    if (fields.length <= 0) {
        fields.push();
    }

    return (
        <div className="accordion-wrap">
            <div className="button-container">
                <FormElems.Button
                    customClass="add-button"
                    buttonType="secondary"
                    id={`add-${addButtonText}`}
                    text={`+ ${addButtonText}`}
                    type="button"
                    isDisable={isViewMode}
                    handleClick={() => fields.push()}
                />
            </div>
            {fields.map((item, index) => (
                <div
                    key={index}
                    className={` ${index > 0 ? 'additional-field' : ''}`}
                >
                    {shouldShowRemove && index > 0 ? (
                        <div className="button-container">
                            <FormElems.Button
                                customClass="remove-button"
                                buttonType="secondary"
                                id={`remove-${item}-issuerId`}
                                text={`x ${removeButtonText}`}
                                type="button"
                                isDisable={isViewMode}
                                handleClick={() => fields.remove(index)}
                            />
                        </div>
                    ) : (
                        <></>
                    )}
                    <div className={`fields-container`}>
                        {configData.length &&
                            configData.map(field =>
                                field.onlyAfterDefault && index <= 0 ? (
                                    <></>
                                ) : (
                                    <div
                                        className={`${
                                            field.name === 'status'
                                                ? 'credential-status-field'
                                                : ''
                                        } form-field`}
                                        key={field.label}
                                    >
                                        <p className="label">{field.label}</p>
                                        <FormField
                                            field={field}
                                            isViewMode={isViewMode}
                                            item={item}
                                            fields={fields}
                                            index={index}
                                            customFieldOptions={
                                                customFieldOptions
                                            }
                                        />
                                    </div>
                                )
                            )}
                    </div>
                </div>
            ))}
        </div>
    );
};

DynamicFieldsController.propTypes = {
    fields: PropTypes.array,
    meta: PropTypes.object,
    properties: PropTypes.object,
};

const AccordionFields = props => {
    const {
        name,
        isViewMode,
        configData,
        customFieldOptions,
        shouldShowRemove,
    } = props;

    const properties = {
        addButtonText: 'Add Credentials',
        removeButtonText: 'Remove',
        isViewMode,
        configData,
        customFieldOptions,
        shouldShowRemove,
    };

    return (
        <FieldArray
            name={name}
            component={DynamicFieldsController}
            properties={properties}
        />
    );
};

AccordionFields.propTypes = {
    fields: PropTypes.object,
    mode: PropTypes.string,
    name: PropTypes.string,
    isViewMode: PropTypes.bool,
    configData: PropTypes.bool,
    customFieldOptions: PropTypes.array,
    shouldShowRemove: PropTypes.bool,
};

export default AccordionFields;
